const errorCodeConstants = {
  UNAUTHORIZED: "UNAUTHORIZED",
};

const errorConstants = {
  GENERIC_ERROR: "Something went wrong , Try again",
};

export { errorCodeConstants, errorConstants };
